import { clinicalApiPath, viperApi } from '@/services/viper-api'
import * as qs from 'qs'
export class OrganizationTrialService {
  /**
   * Constructs OrganizationTrialService
   * @param api {AxiosInstance}
   * @param basePath {String}
   */
  constructor(api, basePath) {
    this.api = api
    this.basePath = basePath
  }

  /**
   * Updates organization trial's target enrollment, and activated date
   * @param organizationId
   * @param trialId
   * @param dto { targetEnrollment, recruitingStartDate, externalId }
   * @returns {*}
   */
  update(organizationId, trialId, dto) {
    return viperApi.put(
      `${this.basePath}/organization-trials/organization/${organizationId}/trial/${trialId}`,
      dto
    )
  }

  parentUpdate(organizationId, trialId, dto) {
    return viperApi.put(
      `${this.basePath}/organization-trials/organization/${organizationId}/trial/${trialId}/parent`,
      dto
    )
  }

  getUnidentifiedTrialsForPatient(organizationId, patientId) {
    return viperApi.get(
      `${this.basePath}/organization-trials/organization/${organizationId}/patient/${patientId}/unidentified-trials`
    )
  }

  updateAutoMarkNegativeFindings(organizationId, trialId, toggle) {
    return viperApi.post(
      `${this.basePath}/organization-trials/organization/${organizationId}/trial/${trialId}/auto-update-non-eligible-patients`,
      `${toggle}`
    )
  }

  existsByOrganizationAndExternalId(organizationId, trialId, externalId) {
    const params = { externalId }
    return viperApi.get(
      `${this.basePath}/organization-trials/organization/${organizationId}/trial/${trialId}/exists`,
      {
        params,
        paramsSerializer: function(params) {
          return qs.stringify(params, { allowDots: true, arrayFormat: 'repeat' })
        }
      }
    )
  }
}

export default new OrganizationTrialService(viperApi, clinicalApiPath)
